import React, {useEffect} from "react";
import Container from "@material-ui/core/Container";
import { Card, Grid, Box, Hidden, useMediaQuery, useTheme } from "@material-ui/core";
import Navigation from "../../Components/Navigation";
import BasicInfo from "../../Components/BasicInfo";
import MainInfo from "../../Components/MainInfo";
import PartnerAdminInfo from "../../Components/PartnerAdminInfo";
import { IsOnBoardingContext } from "../../App";

import API from "../../helpers/apiHelpers";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";

const DashbordProfile = () => {
    const role = useSelector((state: RootState) => state?.user.role);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    return (
        <Container maxWidth="md" style={{marginBottom: 75}}>
            <Box marginTop="115px">
                <Grid container>
                    {!isMobile &&
						<Grid item md={3} xs={12}>
						    <Navigation />
						</Grid>
                    }
                    <Grid item md={9} xs={12}>
                        <Card variant="outlined">
                            {
                                role === "VET" ?
                                    <IsOnBoardingContext.Consumer>
                                        {({isOnBoarding, setIsOnBoarding}) => <MainInfo isOnBoarding={isOnBoarding} setIsOnBoarding={setIsOnBoarding}/>}
                                    </IsOnBoardingContext.Consumer>
                                    : role === "PARTNER" ?
                                        <IsOnBoardingContext.Consumer>
                                            {({isOnBoarding, setIsOnBoarding}) => <PartnerAdminInfo isOnBoarding={isOnBoarding} setIsOnBoarding={setIsOnBoarding}/>}
                                        </IsOnBoardingContext.Consumer>
                                        :
                                        <IsOnBoardingContext.Consumer>
                                            {({isOnBoarding, setIsOnBoarding}) => <BasicInfo isOnBoarding={isOnBoarding} setIsOnBoarding={setIsOnBoarding}/>}
                                        </IsOnBoardingContext.Consumer>
                            }
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default DashbordProfile;
